import { axiosInstance } from './axios.service'
import { IResponse } from '../types/response.type'
import { NodeTypeEndpoints } from '../types/endpoint.type'
import {
  INodeType,
  IAllNodeTypesResponse,
} from '../../shared/types/api/playbook.type'

export const getAllNodeTypes = async (): Promise<IResponse<INodeType[]>> => {
  try {
    const resp = await axiosInstance.get<IAllNodeTypesResponse>(
      NodeTypeEndpoints.GET_ALL,
    )

    return resp.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}
